export default __webpack_public_path__ + "static/media/architecture.dfe89471.png";